// src/components/select/DomainFilterSelector.tsx

import { CancelTwoTone, FilterAltTwoTone } from '@mui/icons-material'
import { MenuItem } from '@mui/material'
import { useEffect, useState } from 'react'

import { KSelect } from '../../components'
import { useUserApi } from '../../hooks'

type DomainFilterSelectorProps = {
  onClear: () => void
  onSelect: (domain: string) => void
  value: string
}

export const DomainFilterSelector = ({
  onClear,
  onSelect,
  value,
}: DomainFilterSelectorProps) => {
  const { getEmailDomains } = useUserApi()

  const [domains, setDomains] = useState([])

  useEffect(() => {
    const fetchDomains = async () => {
      const domains = await getEmailDomains()
      setDomains(domains)
    }

    fetchDomains()
  }, [getEmailDomains])

  return (
    <KSelect
      icon={<FilterAltTwoTone />}
      label={'Domain Filter'}
      sx={{ minWidth: 110 }}
      value={value}
    >
      <MenuItem disabled={value === ''} onClick={onClear} value={''}>
        <CancelTwoTone sx={{ mr: 1 }} />
        Zurücksetzen
      </MenuItem>

      {domains.map(domain => {
        const onClick = () => onSelect(domain)

        return (
          <MenuItem onClick={onClick} key={domain} value={domain}>
            {domain}
          </MenuItem>
        )
      })}
    </KSelect>
  )
}
